export default function (): void {
  document.querySelectorAll<HTMLElement>('.product__reviews-content .toggle-text').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()
      const target = e.target as HTMLElement
      const parentEl = target.parentNode

      if (!parentEl) {
        return
      }

      const hiddenTextEl = (target.parentNode as HTMLElement).querySelector('.hidden-text')
      const hiddenTextParentEl = hiddenTextEl?.parentNode as HTMLElement

      hiddenTextParentEl.removeChild(parentEl?.querySelector('.ellipsis') as HTMLElement)
      hiddenTextParentEl.querySelector('.hidden-text')?.classList.remove('hidden-text')

      parentEl.removeChild(target)
    })
  })
}
